module.exports = __webpack_public_path__ + "img/timeIcon.21b96e58.svg";